import React, { Component } from 'react';

import ZHttp from '../services/AccountService';
import AccountService from '../services/AccountService';

import LocalDataManager from '../managers/LocalDataManager';

import LogoVert from './SVG/LogoVert';
import LoginViewCentral from './Login/LoginViewCentral';
import LoginViewTour from './Login/LoginViewTour';

export default class LoginPage extends Component {

    constructor(props) {
        super(props);

        this.dbm = new LocalDataManager();

        this.defaultProps = {}

        this.state = {
            mode: 'splash',
            submode: 'main',
            tourPageIndex: 0,
            innerOpacity: '1',
            externalInfo: {
                type: '',
                id: ''
            },
            internalInfo: {
                firstName: '',
                lastName: '',
                email: '',
                phone: ''
            },
            autoFillInfo: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                picture: ''
            }
        }

        let self = this;
        this.accountService = new AccountService();

        this.handleStandardLogin = this.handleStandardLogin.bind(this);
        this.handleLoginAddSocial = this.handleLoginAddSocial.bind(this);
        this.handleFacebookLogin = this.handleFacebookLogin.bind(this);
        this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
        //this.handleInstagramLogin = this.handleInstagramLogin.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.handleComingSoonLogin = this.handleComingSoonLogin.bind(this);

        this.changeView = this.changeView.bind(this);
        this.changeSubView = this.changeSubView.bind(this);
        this.changeViewExternal = this.changeViewExternal.bind(this);
        this.changeViewInternal = this.changeViewInternal.bind(this);

        this.tourPageNext = this.tourPageNext.bind(this);
        this.tourPagePrevious = this.tourPagePrevious.bind(this);

        this.viewPrivacyPolicy = this.viewPrivacyPolicy.bind(this);

        this.linkAccountAndLogin = this.linkAccountAndLogin.bind(this);
        this.createNewAccount = this.createNewAccount.bind(this);

        window.zzResume = () => { };
        window.zzPause = () => { };

        this.props.loadingOff();
    }

    componentDidMount() {
        var self = this;
        var timeout = setTimeout(function () {
            self.setState({
                mode: 'main'
            });
        }, 100)
    }

    componentWillReceiveProps() { }

    handleStandardLogin(username, password) {
        var self = this;
        this.props.loadingOn(() => {
            self.accountService.login(username, password,
                function () {
                    self.dbm.getAccountInfo().then((accountInfo) => { 
                        if(self.props.isPhone && accountInfo.isDashboardOnly){
                            self.props.loadingOff();
                            self.setState({ loginErrorMessage: "Account not authorized for mobile access." });
                        }
                        else{
                            self.props.loginComplete();
                            self.setState({ loginErrorMessage: null });
                        }
                    })   
                }, function (errMessage) {
                    self.props.loadingOff();
                    self.setState({ loginErrorMessage: errMessage != undefined ? errMessage : "The user name or password is incorrect." });
                });
        });
    }

    handleLoginAddSocial(username, password) {
        this.props.loadingOn();
        var self = this;

        self.accountService.loginAddSocial(username, password, this.state.externalInfo.type, this.state.externalInfo.id, this.state.autoFillInfo.picture, function () {
            //self.props.loadingOff();
            self.dbm.getAccountInfo().then((accountInfo) => { 
                if(self.props.isPhone && accountInfo.isDashboardOnly){
                    self.props.loadingOff();
                }
                else{
                    self.props.loginComplete();
                }
            })
        }, function (err) {
            self.props.loadingOff();

        });
    }

    handleFacebookLogin() {

        this.props.loadingOn();
        var self = this;

        try {

            if (window.ZeeZorRunningOnDevice) {

                CordovaFacebook.login({
                    permissions: ['email', 'public_profile'],
                    onSuccess: function (res) {

                        self.accountService.getFacebookInfo(res.accessToken, (fbEmailResponse) => {
                            try {

                                let facebookData = {
                                    firstName: fbEmailResponse.first_name,
                                    lastName: fbEmailResponse.last_name,
                                    email: fbEmailResponse.email,
                                    phone: '',
                                    picture: fbEmailResponse.picture.data.url
                                };

                                // self.accountService.loginExternal("facebook", fbEmailResponse.id, facebookData.picture,
                                self.accountService.loginExternal("facebook", res.accessToken, facebookData.picture,

                                    function (type, id) {
                                        //self.props.loadingOff();
                                        self.dbm.getAccountInfo().then((accountInfo) => { 
                                            if(this.state.isPhone && accountInfo.isDashboardOnly){
                                                self.props.loadingOff();
                                                alert("Could not authenticate with Facebook");
                                            }
                                            else{
                                                self.props.loginComplete();
                                            }
                                        })
                                    }, function (type, id) {

                                        self.props.loadingOff();
                                        alert("Could not authenticate with Facebook");

                                        // self.setState({
                                        //     autoFillInfo: facebookData
                                        // });
                                        // self.accountService.checkEmailMatch(facebookData.email, function (usr) {
                                        //     self.props.loadingOff();
                                        //     self.changeViewInternal('you', type, id, usr);
                                        // }, function (err) {
                                        //     self.props.loadingOff();
                                        //     self.changeViewExternal('zconfirm', type, id);
                                        // });
                                    });
                            } catch (ex) {
                                self.props.loadingOff();
                                alert("Could not connect to server");
                            }
                        }, (err) => {
                            self.props.loadingOff();
                        });
                    },
                    onFailure: function (err) {
                        self.props.loadingOff();
                        if (err.cancelled) {

                        } else if (err.error) {

                        }
                    }
                });


            } else {

                FB.getLoginStatus((obj) => {
                    if (obj.status === 'connected') {
                        FB.api('/me', { fields: 'email,first_name,last_name,picture.type(large)' }, function (fbEmailResponse) {

                            try {
                                let facebookData = {
                                    firstName: fbEmailResponse.first_name,
                                    lastName: fbEmailResponse.last_name,
                                    email: fbEmailResponse.email,
                                    phone: '',
                                    picture: fbEmailResponse.picture.data.url
                                };

                                let fbAccessToken = obj.authResponse.accessToken;

                                // self.accountService.loginExternal("facebook", fbEmailResponse.id, facebookData.picture,
                                self.accountService.loginExternal("facebook", fbAccessToken, facebookData.picture,

                                    function (type, id) {
                                        //self.props.loadingOff();
                                        self.dbm.getAccountInfo().then((accountInfo) => { 
                                            if(self.props.isPhone && accountInfo.isDashboardOnly){
                                                self.props.loadingOff();
                                                alert("Could not authenticate with Facebook");
                                            }
                                            else{
                                                self.props.loginComplete();
                                            }
                                        })
                                    }, function (type, id) {

                                        self.props.loadingOff();
                                        alert("Could not authenticate with Facebook");

                                        // FB.api('/me', {
                                        //     fields: 'email,first_name,last_name,picture'
                                        // }, function (fbEmailResponse) {

                                        //     self.setState({
                                        //         autoFillInfo: facebookData
                                        //     });
                                        //     self.accountService.checkEmailMatch(fbEmailResponse.email, function (usr) {
                                        //         self.props.loadingOff();
                                        //         self.changeViewInternal('you', type, id, usr);
                                        //     }, function (err) {
                                        //         self.props.loadingOff();
                                        //         self.changeViewExternal('zconfirm', type, id);
                                        //     });
                                        // })
                                    });
                            } catch (ex) {
                                self.props.loadingOff();
                                alert("Could not connect to server");
                            }
                        })
                    } else {
                        FB.login(function (res) {
                            FB.api('/me', { fields: 'email,first_name,last_name,picture.type(large)' }, function (fbEmailResponse) {

                                try {
                                    let facebookData = {
                                        firstName: fbEmailResponse.first_name,
                                        lastName: fbEmailResponse.last_name,
                                        email: fbEmailResponse.email,
                                        phone: '',
                                        picture: fbEmailResponse.picture.data.url
                                    };


                                    let fbAccessToken = res.authResponse.accessToken;

                                    // self.accountService.loginExternal("facebook", fbEmailResponse.id, facebookData.picture,
                                    self.accountService.loginExternal("facebook", fbAccessToken, facebookData.picture,

                                        function (type, id) {
                                            //self.props.loadingOff();
                                            self.dbm.getAccountInfo().then((accountInfo) => { 
                                                if(self.props.isPhone && accountInfo.isDashboardOnly){
                                                    self.props.loadingOff();
                                                    alert("Could not authenticate with Facebook");
                                                }
                                                else{
                                                    self.props.loginComplete();
                                                }
                                            })
                                        }, function (type, id) {

                                            self.props.loadingOff();
                                            alert("Could not authenticate with Facebook");

                                            // FB.api('/me', {
                                            //     fields: 'email,first_name,last_name,picture'
                                            // }, function (fbEmailResponse) {

                                            //     self.setState({
                                            //         autoFillInfo: facebookData
                                            //     });
                                            //     self.accountService.checkEmailMatch(fbEmailResponse.email, function (usr) {
                                            //         self.props.loadingOff();
                                            //         self.changeViewInternal('you', type, id, usr);
                                            //     }, function (err) {
                                            //         self.props.loadingOff();
                                            //         self.changeViewExternal('zconfirm', type, id);
                                            //     });
                                            // })
                                        });
                                } catch (ex) {
                                    self.props.loadingOff();
                                    alert("Could not connect to server");
                                }
                            })

                        }, {
                            scope: 'email,public_profile'
                        });
                    }
                })
            }
        } catch (ex) {
            self.props.loadingOff();
            alert("Could not connect to server");
        }
    }

    handleGoogleLogin() {

        this.props.loadingOn();
        var self = this;

        let webClientIdWeb = '188952832886-5ge9kagr4r1cgcm9ep65fr76780f5upp.apps.googleusercontent.com';
        let webClientIdIos = '188952832886-se8vf4aqsckhbn6iqlvc2a1ertq1ua3s.apps.googleusercontent.com';

        try {
            if (window.ZeeZorRunningOnDevice) {
                window.plugins.googleplus.login(
                    {
                        //'scopes': '',
                        'webClientId': webClientIdWeb
                    },
                    function (res) {
                        try {
                            let googleData = {
                                firstName: res.givenName,
                                lastName: res.familyName,
                                email: res.email,
                                phone: '',
                                picture: res.imageUrl
                            };
                            // self.accountService.loginExternal("google", res.userId, googleData.picture,
                            self.accountService.loginExternal("google", res.idToken, googleData.picture,
                                function (type, id) {
                                    //self.props.loadingOff();

                                    self.dbm.getAccountInfo().then((accountInfo) => { 
                                        if(self.props.isPhone && accountInfo.isDashboardOnly){
                                            self.props.loadingOff();
                                            alert("Could not authenticate with Google");
                                        }
                                        else{
                                            self.props.loginComplete();
                                        }
                                    })
                                }, function (type, id) {

                                    self.props.loadingOff();
                                    alert("Could not authenticate with Google");

                                    // self.setState({
                                    //     autoFillInfo: googleData
                                    // });

                                    // self.accountService.checkEmailMatch(res.email, function (usr) {
                                    //     self.props.loadingOff();
                                    //     self.changeViewInternal('you', type, id, usr);
                                    // }, function (err) {
                                    //     self.props.loadingOff();
                                    //     self.changeViewExternal('zconfirm', type, id);
                                    // });
                                }
                            );
                        } catch (ex) {
                            self.props.loadingOff();
                            alert("Could not connect to server");
                        }
                    },
                    function (err) {
                        self.props.loadingOff();
                        alert("Could not connect to server");
                    }
                );
            } else {
                GoogleAuth.signIn().then(function (res) {
                    try {
                        var googleData = {
                            firstName: res.getBasicProfile().getGivenName(),
                            lastName: res.getBasicProfile().getFamilyName(),
                            email: res.getBasicProfile().getEmail(),
                            phone: '',
                            picture: res.getBasicProfile().getImageUrl()
                        };

                        // self.accountService.loginExternal("google", res.getId(), googleData.picture,
                        self.accountService.loginExternal("google", res.getAuthResponse().id_token, googleData.picture,
                            function (type, id) {
                                //self.props.loadingOff();
                                self.dbm.getAccountInfo().then((accountInfo) => { 
                                    if(self.props.isPhone && accountInfo.isDashboardOnly){
                                        self.props.loadingOff();
                                        alert("Could not authenticate with Google");
                                    }
                                    else{
                                        self.props.loginComplete();
                                    }
                                })
                            }, function (type, id) {

                                self.props.loadingOff();
                                alert("Could not authenticate with Google");

                                // self.setState({
                                //     autoFillInfo: googleData
                                // });
                                // self.accountService.checkEmailMatch(res.getBasicProfile().getEmail(), function (usr) {
                                //     self.props.loadingOff();
                                //     self.changeViewInternal('you', type, id, usr);
                                // }, function (err) {
                                //     self.props.loadingOff();
                                //     self.changeViewExternal('zconfirm', type, id);
                                // });
                            }
                        );
                    } catch (ex) {
                        self.props.loadingOff();
                        alert("Could not connect to server");
                    }
                }, function (err) {
                    self.props.loadingOff();
                });
            }
        } catch (ex) {
            self.props.loadingOff();
            alert("Could not connect to server");
        }
    }

    handleComingSoonLogin(loginName) {
        alert(loginName + " login is no longer supported.");
        return;
    }

    handleForgotPassword(email, successCallback, errorCallback) {
        this.accountService.submitForgotPassword(email, successCallback, errorCallback);
    }

    changeView(view) {

        var self = this;

        this.setState({ innerOpacity: '0' });
        setTimeout(() => {
            if (view === 'main') {
                self.setState({
                    mode: view,
                    submode: 'main',
                    innerOpacity: '1'
                });
            } else if (view === 'remain') {
                self.setState({
                    mode: 'main',
                    innerOpacity: '1'
                });
            } else {
                self.setState({
                    mode: view,
                    innerOpacity: '1'
                });
            }
        }, 100);
    }

    changeSubView(view) {
        var self = this;

        this.setState({ innerOpacity: '0' });
        setTimeout(() => {
            self.setState({
                submode: view,
                innerOpacity: '1'
            });
        }, 100);
    }

    changeViewExternal(view, type, id) {
        var self = this;
        this.setState({ innerOpacity: '0' });
        setTimeout(() => {
            if (view === 'main' && this.state.mode != 'forgot') {
                self.setState({
                    mode: view,
                    submode: 'main',
                    innerOpacity: '1',
                    externalInfo: {
                        type: type,
                        id: id
                    },
                    autoFillInfo: {
                        firstName: '',
                        lastName: '',
                        email: '',
                        phone: '',
                        picture: ''
                    }
                });
            } else {
                self.setState({
                    mode: view,
                    innerOpacity: '1',
                    externalInfo: {
                        type: type,
                        id: id
                    }
                });
            }
        }, 100);
    }

    changeViewInternal(view, type, id, usr) {
        var self = this;

        this.setState({ innerOpacity: '0' });
        setTimeout(() => {
            if (view === 'main') {
                self.setState({
                    mode: view,
                    submode: 'main',
                    innerOpacity: '1',
                    externalInfo: {
                        type: type,
                        id: id
                    },
                    internalInfo: {
                        firstName: usr.firstName,
                        lastName: usr.lastName,
                        email: usr.email,
                        phone: usr.phone
                    },
                    autoFillInfo: {
                        firstName: '',
                        lastName: '',
                        email: '',
                        phone: '',
                        picture: ''
                    }
                });
            } else {
                self.setState({
                    mode: view,
                    innerOpacity: '1',
                    externalInfo: {
                        type: type,
                        id: id
                    },
                    internalInfo: {
                        firstName: usr.firstName,
                        lastName: usr.lastName,
                        email: usr.email,
                        phone: usr.phone
                    }
                });
            }
        }, 100);
    }

    tourPageNext() {
        if (this.state.tourPageIndex === 4) {
            this.setState({
                tourPageIndex: 0
            });
        } else {
            this.setState({
                tourPageIndex: ++this.state.tourPageIndex
            });
        }
    }

    tourPagePrevious() {
        if (this.state.tourPageIndex > 0) {
            this.setState({
                tourPageIndex: --this.state.tourPageIndex
            });
        }
    }

    viewPrivacyPolicy() {
        if (usingiOS && window.hasOwnProperty('cordova')) {
                cordova.InAppBrowser.open('https://company.mindbodyonline.com/legal/privacy-policy', '_system');
        }
        else {
            window.open('https://company.mindbodyonline.com/legal/privacy-policy', '_system');
            }
        return false;
    }

    linkAccountAndLogin() {
        this.props.loadingOn();
        var self = this;

        this.accountService.linkAccount(this.state.internalInfo.email, this.state.externalInfo.type, this.state.externalInfo.id,
            function (res) {
                self.accountService.loginExternal(self.state.externalInfo.type, self.state.externalInfo.id, function () {
                    //self.props.loadingOff();
                    self.setState({
                        externalInfo: {
                            type: '',
                            id: ''
                        },
                        internalInfo: {
                            firstName: '',
                            lastName: '',
                            email: '',
                            phone: ''
                        }
                    });
                    self.props.loginComplete();
                }, function (err) {
                    self.props.loadingOff();
                })
            }, function (err) {
                self.props.loadingOff();
            })
    }

    createNewAccount(data) {
        this.props.loadingOn();
        var self = this;

        if (this.state.externalInfo.type != 'google') {
            data.googleId = null;
            data.googlePicUrl = null;
        }
        if (this.state.externalInfo.type != 'instagram') {
            data.instagramId = null;
            data.instagramPicUrl = null;
        }
        if (this.state.externalInfo.type != 'facebook') {
            data.facebookId = null;
            data.facebookPicUrl = null;
        }

        if (this.state.externalInfo.type === 'google') {
            data.avatarUrl = data.googlePicUrl;
            data.avatarType = 'google';
        }
        if (this.state.externalInfo.type === 'instagram') {
            data.avatarUrl = data.instagramPicUrl;
            data.avatarType = 'instagram';
        }
        if (this.state.externalInfo.type === 'facebook') {
            data.avatarUrl = data.facebookPicUrl;
            data.avatarType = 'facebook';
        }

        this.accountService.createNewAccount(data, function (res) {

            if (res === 'usernameAemail') {
                alert("The username and email provided are already taken");
                self.props.loadingOff();
            } else if (res === 'username') {
                alert("The username provided is already taken");
                self.props.loadingOff();
            } else if (res === 'email') {
                alert("The email provided is already taken");
                self.props.loadingOff();
            } else if (res === 'badpass') {
                alert("The password provided does not meet password requirements");
                self.props.loadingOff();
            } else {
                self.props.loginComplete();
            }

        }, function () {
            self.props.loadingOff();
        });
    }

    render() {

        var logoView = null;
        if (this.state.mode === 'splash') {
            logoView = (
                <div className="splash-logo-container">
                    <LogoVert className="splash-logo-fin" />
                </div>
            );

        } else {

            var logoViewStyle = {};
            /*  if (this.state.submode === 'zlogin' || this.state.mode === 'you' || this.state.mode === 'zconfirm' || this.state.mode === 'new' || this.state.mode === 'forgot') {
                  logoViewStyle = {
                      width: '71%',
                      height: '24.8',
                      left: '14%',
                      top: '3rem'
                  }
              }
              if (this.state.mode === 'new') {
                  logoViewStyle.top = '-20vh';
                  logoViewStyle.opacity = '0';
                  logoViewStyle.transition = 'width 0.5s cubic-bezier(0.38, 0.72, 0.38, 0.78) 0s, left 0.5s cubic-bezier(0.38, 0.72, 0.38, 0.78) 0s, top 0.2s ease-in-out 0.01s, transform 0.2s linear 0s, opacity 0.5s ease-in-out 0s';
              }*/

            logoView = (
                <div onClick={this.changeViewExternal.bind(null, 'main').bind(null, '').bind(null, '')} style={logoViewStyle} className="splash-logo-container splash-logo-container-login">
                    <LogoVert className="splash-logo-fin" />
                </div>
            );
        }

        return (
            <div id="page-outer" className="login-page-outer">
                <div className="login-logo-view-outer-outer">{logoView}</div>
                <LoginViewCentral
                    handleStandardLogin={this.handleStandardLogin}
                    handleFacebookLogin={this.handleComingSoonLogin.bind(null, "Facebook")}
                    handleInstagramLogin={this.handleComingSoonLogin.bind(null, "Instagram")}
                    handleGoogleLogin={this.handleComingSoonLogin.bind(null, "Google")}
                    handleLoginAddSocial={this.handleLoginAddSocial}
                    handleForgotPassword={this.handleForgotPassword}
                    linkAccountAndLogin={this.linkAccountAndLogin}
                    createNewAccount={this.createNewAccount}
                    changeView={this.changeView}
                    changeViewInternal={this.changeViewInternal}
                    changeViewExternal={this.changeViewExternal}
                    changeSubView={this.changeSubView}
                    tourStart={this.tourPageNext}
                    tutorialOn={this.props.tutorialOn}
                    viewPrivacyPolicy={this.viewPrivacyPolicy}
                    mode={this.state.mode}
                    submode={this.state.submode}
                    loginErrorMessage={this.state.loginErrorMessage}
                    internalInfo={this.state.internalInfo}
                    externalInfo={this.state.externalInfo}
                    autoFillInfo={this.state.autoFillInfo}
                    innerOpacity={this.state.innerOpacity} />

                <LoginViewTour
                    pageIndex={this.state.tourPageIndex}
                    pagePrevious={this.tourPagePrevious}
                    pageNext={this.tourPageNext} />
            </div>
        );
    }
}
